import * as type from '../types'

const initialState = {
  userDetails: [],
  loading: false,
}

export default function user(state = initialState, action) {
  switch (action.type) {
    case type.GET_USER_DETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case type.GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        userDetails: action.userDetails,
      }
    case type.GET_USER_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
    case type.UPDATE_USER_DETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case type.UPDATE_USER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case type.UPDATE_USER_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
    default:
      return state
  }
}
